type Environment = "local" | "dev" | "int" | "prod";

const baseUrlByHosts: Record<Environment, string[]> = {
  local: ["localhost"],
  dev: [
    "dev.sww-static.apps.gs-ch-prod.camptocamp.com",
    "dev.sww-static.apps.green.gs-ch-prod.camptocamp.com",
    "dev.sww-static.apps.blue.gs-ch-prod.camptocamp.com",
  ],
  int: [
    "int.sww-static.apps.gs-ch-prod.camptocamp.com",
    "int.sww-static.apps.green.gs-ch-prod.camptocamp.com",
    "int.sww-static.apps.blue.gs-ch-prod.camptocamp.com",
  ],
  prod: [
    "prod.sww-static.apps.gs-ch-prod.camptocamp.com",
    "prod.sww-static.apps.green.gs-ch-prod.camptocamp.com",
    "prod.sww-static.apps.blue.gs-ch-prod.camptocamp.com",
  ],
};

const baseUrlByEnvironment: Record<Environment, string> = {
  local: "http://localhost:8080",
  dev: "https://dev.sww-geo.apps.gs-ch-prod.camptocamp.com",
  int: "https://int.sww-geo.apps.gs-ch-prod.camptocamp.com",
  prod: "https://prod.sww-geo.apps.gs-ch-prod.camptocamp.com",
};

let environment: Environment;
let jwtToken = "";

/**
 * Set the environment: `local`, `dev`, `int` or `prod`.
 * If not set, the environment is guessed from the origin and will be `prod` if not found.
 */
export function setEnvironment(env: Environment | undefined = undefined): Environment {
  environment = env === undefined ? guessEnvironment() : env;
  return environment;
}

/**
 * Get the base URL of the API for the current environment.
 */
export function getAPIBaseUrl() {
  return baseUrlByEnvironment[environment];
}

/**
 * Guess the environment from the origin or return `prod` if not found.
 */
export function guessEnvironment(): Environment {
  for (const [env, hosts] of Object.entries(baseUrlByHosts)) {
    if (hosts.includes(window.location.hostname)) {
      return env as Environment;
    }
  }
  return "prod";
}

/**
 * Set the JWT token to use for the API calls.
 */
export function setJwtToken(token: string) {
  jwtToken = token;
}

/**
 * Get the JWT token to use for the API calls.
 */
export function getJwtToken() {
  return jwtToken;
}
